/**
 * SearchBar
 *
 * Fixed top-center MGRS search input. Parses user input and calls
 * onSearch({lat, lng}) to fly the map to the decoded location.
 */

import React, { useState } from 'react'
import { parseMgrsInput, mgrsToLatLng } from '../utils/mgrsConvert.js'

/**
 * @param {{ onSearch: (coords: {lat: number, lng: number}) => void }} props
 */
export function SearchBar({ onSearch }) {
  const [value, setValue] = useState('')
  const [error, setError] = useState(false)

  function handleKeyDown(e) {
    if (e.key !== 'Enter') return

    const raw = value.trim()
    if (!raw) return

    try {
      const normalized = parseMgrsInput(raw)
      const coords = mgrsToLatLng(normalized)

      if (
        coords &&
        typeof coords.lat === 'number' &&
        typeof coords.lng === 'number' &&
        !Number.isNaN(coords.lat) &&
        !Number.isNaN(coords.lng)
      ) {
        setError(false)
        onSearch(coords)
      } else {
        setError(true)
      }
    } catch {
      setError(true)
    }
  }

  function handleChange(e) {
    setValue(e.target.value)
    if (error) setError(false)
  }

  return (
    <div className={`search-bar${error ? ' search-bar--error' : ''}`}>
      <span className="search-icon" aria-hidden="true">
        &#x2316;
      </span>
      <input
        type="text"
        className="search-input"
        placeholder="MGRS (e.g. 15T WK 85 42)"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        aria-label="MGRS search"
        aria-invalid={error}
      />
    </div>
  )
}

export default SearchBar
